import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import { Placement } from 'swag-client-common/constants';
import { OrderStorageTypes } from 'swag-common/constants/main-swag.constants';
import { Color } from 'swag-client-common/components/ui/color';
import classes from './shared-item-info.scss';
const tooltipClasses = {
  popper: classes.popper,
  tooltip: classes.tooltip
};
const popperProps = {
  modifiers: {
    offset: {
      enabled: true,
      offset: '0 14px'
    }
  }
};
const SharedItemNote = ({
  isSharedItem,
  isLimitedEdition,
  className = '',
  storage = OrderStorageTypes.CART,
  totalQuantity,
  sharedItemsInfo = []
}) => {
  if (!isSharedItem) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.note
  }, "You have a total of ", totalQuantity, " in your ", storage, ".", ' '), /*#__PURE__*/React.createElement(Tooltip, {
    interactive: true,
    dataBlock: "SharedBreakdown",
    title: sharedItemsInfo.map(({
      name,
      variantsInfo
    }) => /*#__PURE__*/React.createElement("div", {
      "data-block": "Product",
      key: name,
      className: classes.tooltipInfoBlock
    }, /*#__PURE__*/React.createElement("h6", {
      "data-text": "ProductName"
    }, name), variantsInfo.map(({
      color,
      colorName,
      quantity
    }) => /*#__PURE__*/React.createElement("div", {
      className: classes.colorLine,
      "data-block": "ColorLine",
      key: color
    }, /*#__PURE__*/React.createElement(Color, {
      name: colorName,
      color: color,
      className: classes.color
    }), /*#__PURE__*/React.createElement("p", {
      "data-text": "Quantity"
    }, quantity))))),
    placement: Placement.BOTTOM,
    className: classnames(classes.tooltipText, {
      [classes.orangeColor]: isLimitedEdition
    }),
    classes: tooltipClasses,
    PopperProps: popperProps,
    mode: "light"
  }, /*#__PURE__*/React.createElement("span", null, "See breakdown")));
};
export default SharedItemNote;